import React, { useState } from 'react';
import image241 from './Gallery/Image/G14.jpg';
import image242 from './Gallery/Image/G7.jpg';
import image243 from './Gallery/Image/G6.jpg';
import image244 from './Gallery/Image/G4.jpg';
import image245 from './Gallery/Image/G5.jpg';
import image246 from './Gallery/Image/G10.jpg';
import image247 from './Gallery/Image/H1.jpg';
import image248 from './Gallery/Image/H2.jpg';
import image249 from './Gallery/Image/H3.jpg';
import image250 from './Gallery/Image/H4.jpg';
import image251 from './Gallery/Image/H5.jpg';
import image252 from './Gallery/Image/H8.jpg';
import { Link } from 'react-router-dom';


const Gallery = () => {
  const [activeTab, setActiveTab] = useState('2025-26');

  const images = {
    '2025-26':[image247, image248, image249, image250, image251, image252],
    '2024-25': [image241, image242, image243, image244, image245, image246],
  };
  const sortedYears = Object.keys(images).sort((a, b) => b - a);
  return (
    <section className="text-center justify-center items-center mx-auto m-2 md:my-10 md:px-[9rem]">
      <div className="md:my-10 my-2">
        <h2 className="text-center text-3xl font-bold text-[#3b0067] pb-4">Gallery</h2>

        {/* Year Tabs */}
        <div className="flex justify-center mb-5">
          {sortedYears.map((year) => (
            <button
              key={year}
              className={`px-7 py-1 m-2 rounded-md text-sm ${
                activeTab === year
                  ? 'bg-[#ffbd00] text-black font-semibold'
                  : 'bg-[#3b0067] text-white font-semibold'
              } rounded`}
              onClick={() => setActiveTab(year)}
            >
              {year}
            </button>
          ))}
        </div>

        {/* Images */}
        <div className="grid md:grid-cols-3 grid-cols-2 gap-6 md:mx-24 my-1">
          {images[activeTab].map((src, index) => (
            <div key={index} className="rounded-lg bg-[#3b0067] p-2">
              <img
                src={src}
                alt={`Gallery ${activeTab} - ${index + 1}`}
                className="w-full h-auto rounded-lg"
              />
            </div>
          ))}
        </div>
      </div>

      <Link to="/Gallery">
        <button className="bg-[#ffbd00] px-8 py-1.5 text-sm rounded-md text-black font-medium">
          View All
        </button>
      </Link>
    </section>
  );
};

export default Gallery;
